import { useState } from 'react'

import EditIcon from '@/assets/icons/icon-edit.svg'
import IconMore from '@/assets/icons/icon-menu-more.svg'
import RemoveIcon from '@/assets/icons/icon-trash.svg'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  disabled: boolean
  onEdit: () => void
  onRemove: () => void
}
export const EditSequenceTableActionsDropdown = ({
  disabled,
  onEdit,
  onRemove,
}: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <DropdownMenu
      open={isMenuOpen}
      onOpenChange={setIsMenuOpen}
    >
      <DropdownMenuTrigger className="cursor-pointer">
        <IconMore className="h-5 w-5 text-title hover:text-secondary-300" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-40 p-1"
        forceMount
      >
        <DropdownMenuItem
          onClick={onEdit}
          className={classNames('cursor-pointer text-primary-500', {
            'opacity-50': disabled,
          })}
        >
          <EditIcon
            width={18}
            height={18}
          />
          Edit
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={onRemove}
          className={classNames('cursor-pointer text-danger-default', {
            'opacity-50': disabled,
          })}
        >
          <RemoveIcon
            width={18}
            height={18}
          />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
